import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Virtuoso } from "react-virtuoso";
import { FeedItem } from "../../components/Feed/FeedItem";
import { getFollowingPosts } from "../../redux/actions/postActions";
import SkeletonPost from "../SkeletonPost/SkeletonPost";

const Following = () => {
  const { t } = useTranslation();
  const [page, setPage] = useState(1);
  const dispatch = useDispatch();
  const postState = useSelector((state) => state.post);
  const { modifiedPost, followingPosts, newPost, newRepost } = postState;
  // 1. ADD THE SAME LIMIT CONSTANT HERE
  const POST_FEED_LIMIT = 20;
  useEffect(() => {
    dispatch(getFollowingPosts(page));
  }, [page, modifiedPost, newPost, newRepost, dispatch]);

  return (
    <>
      {followingPosts ? (
        followingPosts.length > 0 ? (
          <Virtuoso
            style={{ height: "100%" }}
            data={followingPosts}
            // endReached={() => setPage(page + 1)}
            endReached={() => {
              if (page * POST_FEED_LIMIT > followingPosts.length) return;
              setPage(page + 1);
            }}
            itemContent={(index, post) => {
              return <FeedItem key={post._id} post={post} index={index} />;
            }}
            increaseViewportBy={{ top: 300, bottom: 400 }}
          />
        ) : (
          <div className="display-flex flex-direction-c align-items-c">
            <div className="view-wrapper">
              <h1>{t("noPostsTitle")}</h1>
              <p>{t("noPostsText")}</p>
            </div>
          </div>
        )
      ) : (
        // <Spinner />
        <>
          <SkeletonPost />
          <SkeletonPost />
          <SkeletonPost />
        </>
      )}
    </>
  );
};

export default Following;
